import { useState } from 'react'
import { Mail, Plus } from 'lucide-react'
import { CampaignList } from '@components/campaigns/CampaignList'
import { CreateCampaignDialog } from '@components/campaigns/CreateCampaignDialog'

export function CampaignsPage() {
  const [showCreateModal, setShowCreateModal] = useState(false)

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="icon-container icon-container-lg">
            <Mail size={24} className="text-cyan-500" />
          </div>
          <h1 className="text-3xl font-bold text-slate-100">Campaigns</h1>
        </div>
        <button
          onClick={() => setShowCreateModal(true)}
          className="btn-primary"
        >
          <Plus size={20} />
          New Campaign
        </button>
      </div>

      <CampaignList />

      <CreateCampaignDialog
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onSuccess={() => {
          setShowCreateModal(false)
        }}
      />
    </div>
  )
}
